import React from "react";
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
    icon: {
        float: 'left',
        margin: '3px 8px 3px 0px',
        fontSize: '0px'
    },
    text: {
        float: 'right',
        margin: '5px 0px 5px 0px'
    }
});

export default function PrivateIcon(props) {
    const classes = useStyles();

    return (
        <>
            <span css={`
                display: inline-block;
                padding: 0 13px;
                font-size: 0.875rem;
                border: 1px solid #3d964f;
                color: #3d964f;
                border-radius: 25px;
                background-color: transparent;
                vertical-align: top;
                width:110px;
            `}>
                <span className={classes.icon}>
                    <LockOutlinedIcon/>
                </span>
                <span className={classes.text}>
                    Private
                </span>
            </span>
        </>
    )

}